import Component from '../../../assets/scripts/modules/component'
import fireCustomEvent from '../../../assets/scripts/utilities/fire-custom-event'

function getCookie (name) {
  const parts = `; ${document.cookie}`.split(`; ${name}=`)
  return parts.length < 2 ? undefined : parts.pop().split(';').shift()
}

export default class ArticleEmbedBambooHRComponent extends Component {
  init () {
    this.script = this.element.querySelector('script')

    if (!this.script) {
      return
    }

    const cookie = getCookie('cookies-accepted')

    if (!cookie || cookie.split(',').indexOf('personalisation') === -1) {
      this.setupCookieAssistant()
    } else {
      this.initScript()
    }
  }

  setupCookieAssistant () {
    const cookieHlpDiv = this.cookieHlpDiv = this.element.querySelector('.cookie-assistant')
    const btn = cookieHlpDiv.querySelector('button')

    this.element.classList.add('iframe-embed--cookies-not-accepted')

    window.addEventListener('cookies-accepted', (e) => {
      if (e.detail.indexOf('personalisation') > -1) {
        // this.initScript() // nope, need to reload page, otherwise widget won't load properly
        window.location.reload()
      }
    })

    btn.addEventListener('click', event => {
      event.preventDefault()
      fireCustomEvent('show-cookie-details')
    })
  }

  initScript () {
    if (this.is_scriptInited) return
    this.element.classList.remove('iframe-embed--cookies-not-accepted')
    this.script.setAttribute('src', this.script.getAttribute('data-src'))
    this.script.setAttribute('data-src', '')
    this.is_scriptInited = 1
  }
}

window.addEventListener('DOMContentLoaded', () => {
  for (const element of document.querySelectorAll('.article-embed-bamboohr')) {
    element.instance = element.instance || new ArticleEmbedBambooHRComponent(element)
  }
})
